import { MutationLifecycleApi } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { setSnackbar } from '../services/appSlice/appSlice';
import { AppDispatch } from '../app/store';

interface SnackbarText {
  successMessage?: string;
  errorMessage?: string;
}
/** Shows a snackbar based on whether a query is fulfilled or rejected. Duration in ms (default: 5000) */
export const setSnackbarForEndpoint = (
  { queryFulfilled, dispatch }: MutationLifecycleApi<any, any, any>,
  snackbarText: SnackbarText,
  duration = 6000
) => {
  return queryFulfilled
    .then(() => {
      if (snackbarText.successMessage) {
        dispatch(
          setSnackbar({ type: 'success', text: snackbarText.successMessage })
        );
      }
    })
    .catch(() => {
      if (snackbarText.errorMessage) {
        dispatch(
          setSnackbar({ type: 'error', text: snackbarText.errorMessage })
        );
      }
    })
    .finally(() => {
      setTimeout(() => {
        dispatch(setSnackbar(null));
      }, duration);
    });
};

interface SnackbarText {
  successMessage?: string;
  errorMessage?: string;
}

/**
 * Shows a snackbar for 5 seconds with either a success or error message.
 * Call this function directly when you want to show a snackbar.
 */
export const showSnackbar = (
  dispatch: AppDispatch,
  snackbarText: SnackbarText,
  type: 'success' | 'error',
  timeInterval = 6000
) => {
  const text =
    type === 'success' ? snackbarText.successMessage : snackbarText.errorMessage;

  if (!text) return;

  dispatch(setSnackbar({ type, text }));

  setTimeout(() => {
    dispatch(setSnackbar(null));
  }, timeInterval);
};
